import { createGlobalFilter } from "@mostrans/advanced-web-components/helpers/globalFilterHelpers"
import moment from "moment"

export const useGlobalFilter = createGlobalFilter(
    {
        search: "",
        startDate: moment().subtract(2, "month"),
        endDate: moment()
    },
    1000
)